let domain = process.env.VUE_APP_API_DOMAIN;
let mapDomain = process.env.VUE_APP_API_MAP_DOMAIN;
let assetApiDomain = process.env.VUE_APP_API_ASSET_DOMAIN;
let fileUploadUrl = process.env.VUE_APP_API_DOMAIN + "/upload/image";
let fileBase64UploadUrl = process.env.VUE_APP_API_DOMAIN + "/upload/base64Image";
let fileBase64UploadUrlMap = process.env.VUE_APP_API_MAP_DOMAIN + "/upload/base64Image";
let fileUploadUrlMap = process.env.VUE_APP_API_MAP_DOMAIN + "/upload/image";
let webDomain = process.env.VUE_APP_API_WEB_DOMAIN

export default {
  domain: domain,
  fileUploadUrl: fileUploadUrl,
  fileBase64UploadUrl: fileBase64UploadUrl,
  globalMixin: {
    data() {
      return {
        langData: ["English", "Simplified Chinese", "Traditional Chinese"],
        langKey: ["en_US", "zh_CN", "zh_HK"],
        apiDomain: domain,
        mapApiDomain: mapDomain,
        assetApiDomain: assetApiDomain,
        webDomain: webDomain,
        fileUploadUrl: fileUploadUrl,
        fileBase64UploadUrl: fileBase64UploadUrl,
        fileBase64UploadUrlMap: fileBase64UploadUrlMap,
        fileUploadUrlMap: fileUploadUrlMap,
        TOKEN_EXPIRED: 2002,
        apiConfig: {
          login: "/auth/login",
          logout: "/auth/logout",
          prelogin: "/auth/prelogin",

          areaCreate: "/area/create",
          areaDelete: "/area/delete",
          areaDetail: "/area/detail",
          areaList: "/area/list",
          areaUpdate: "/area/update",


          beaconList: "/beacon/list",
          beaconZoneList: "/beaconZone/list",
          presetBeaconList: "/beacon/preset/list",
          PlanningBeaconList: "/beacon/planning/list",

          beaconMessageCreate: "/beaconMessage/create",
          beaconMessageDelete: "/beaconMessage/delete",
          beaconMessageDetail: "/beaconMessage/detail",
          beaconMessageList: "/beaconMessage/list",
          beaconMessageUpdate: "/beaconMessage/update",

          categoryCreate: "/category/create",
          categoryDelete: "/category/delete",
          categoryDetail: "/category/detail",
          categoryList: "/category/list",
          categoryUpdate: "/category/update",
          categoryUpdateOrderType: "/category/update/orderType",
          categoryUpdateSortOrder: "/category/update/sortOrder",
          categoryParentList: "/category/parent/list",

          logActionList: "/log/action/list",
          logDetail: "/log/detail",
          logList: "/log/list",
          logModelList: "/log/model/list",

          monitorHealthCheck: "/monitor/healthcheck",

          poiCreate: "/poi/create",
          poiDelete: "/poi/delete",
          poiDetail: "/poi/detail",
          poiList: "/poi/list",
          poiListAll: "/poi/list/all",
          poiUpdate: "/poi/update",
          poiSave: "/poi/save",
          poiNearestNode: "/poi/nearest/node",
          poiOrdering: "/poi/ordering",
          potDownloadQrcode: "/poi/download/qrcode",

          projectCreate: "/project/create",
          projectDelete: "/project/delete",
          projectDetail: "/project/detail",
          projectList: "/project/list",
          projectUpdate: "/project/update",
          projectLanguage: "/project/language",
          projectlicense: "/project/detail/license",
          projectlicenseApp: "/project/detail/licenseApp",
          projectsystemConfig: "/project/detail/systemConfig",
          projectsavelicense: "/project/save/license",
          projectsavelicenseApp: "/project/save/licenseApp",
          projectsubProjectlist: "/project/subProject/list",
          projectsubProjectoption: "/project/subProject/option",
          projectsubProjectcreate: "/project/subProject/create",
          projectsubProjectdelete: "/project/subProject/delete",

          timeZoneList: "/timeZone/list",

          publishCreate: "/publish/create",
          publishDelete: "/publish/delete",
          publishList: "/publish/list",
          publishSelect: "/publish/select",

          systemFunctionList: "/systemFunction/list",
          systemFunctionProject: "/systemFunction/getListForProject",

          systemGroupCreate: "/systemGroup/create",
          systemGroupDelete: "/systemGroup/delete",
          systemGroupDetail: "/systemGroup/detail",
          systemGroupList: "/systemGroup/list",
          systemGroupUpdate: "/systemGroup/update",

          systemRoleCreate: "/systemRole/create",
          systemRoleDelete: "/systemRole/delete",
          systemRoleDetail: "/systemRole/detail",
          systemRoleList: "/systemRole/list",
          systemRoleUpdate: "/systemRole/update",

          systemUserCreate: "/systemUser/create",
          systemUserDelete: "/systemUser/delete",
          systemUserDetail: "/systemUser/detail",
          systemUserList: "/systemUser/list",
          systemUserUpdate: "/systemUser/update",
          systemUserForgetPassword: "/systemUser/forgetPassword",
          systemUserSendForgetPasswordEmail: "/systemUser/sendForgetPasswordEmail",

          languageList: "/language/list",

          tagCreate: "/tag/create",
          tagDelete: "/tag/delete",
          tagDetail: "/tag/detail",
          tagExist: "/tag/exist",
          tagList: "/tag/list",
          tagUpdate: "/tag/update",

          tagGroupCreate: "/tagGroup/create",
          tagGroupDelete: "/tagGroup/delete",
          tagGroupDetail: "/tagGroup/detail",
          tagGroupExist: "/tagGroup/exist",
          tagGroupList: "/tagGroup/list",
          tagGroupUpdate: "/tagGroup/update",

          uuidsCreate: "/uuids/create",
          uuidsDelete: "/uuids/delete",
          uuidsDetail: "/uuids/detail",
          uuidsList: "/uuids/list",
          uuidsUpdate: "/uuids/update",

          zoneList: "/zone/list",
          zoneListAll: "/zone/list/all",

          alertTemplateSave: "/alertTemplate/save",
          alertTemplateDetail: "/alertTemplate/detail",
          mappingServiceDetail: "/mappingService/detail",
          mappingServiceGetToken: "/mappingService/getToken",

          markerCreate: "/marker/create",
          markerDelete: "/marker/delete",
          markerDetail: "/marker/detail",
          markerList: "/marker/list",
          markerUpdate: "/marker/update",

          mapMarkerCreate: "/map/marker/create",
          mapMarkerDelete: "/map/marker/delete",
          mapMarkerDetail: "/map/marker/detail",
          mapMarkerUpdate: "/map/marker/update",

          mapsCreate: "/maps/create",
          mapsDelete: "/maps/delete",
          mapsDetail: "/maps/detail",
          mapsList: "/maps/list",
          mapsUpdate: "/maps/update",
          mapsUpdateOrder: "/maps/updateOrder",
          mapEditorMaps: "/mapEditor/maps",

          tableauDemo: "/tableau/heatMapOverview",
          heatMapDwellTime: "/tableau/heatMapDwellTime",
          overview: "/tableau/overview",
          dailyAveage: "/tableau/dailyAverage",
          dailyTrend: "/tableau/dailyTrend",
          pathWithDwell: "/tableau/pathWithDwell",

          mapEditorDodes: "/mapEditor/nodes",
          mapEditorPaths: "/mapEditor/paths",
          adaptorList: "/adaptor/list",
          configList: "/config/list",
          getVenueList: "/indoorAtlasService/getVenueList",
          getFloorPlanList: "/indoorAtlasService/getFloorPlanList",


          mapEditorMarkers: "/mapEditor/markers",

          attributeConfigCreate: "/attributeConfig/create",
          attributeConfigList: "/attributeConfig/list",
          attributeConfigDelete: "/attributeConfig/delete",
          attributeConfigDetail: "/attributeConfig/detail",
          attributeConfigUpdate: "/attributeConfig/update",
          attributeConfigTypeList: "/attributeConfig/type/list",
          publishJson: "/publish/json",

          pushMessageCreate: "/pushMessage/create",
          pushMessageDelete: "/pushMessage/delete",
          pushMessageDetail: "/pushMessage/detail",
          pushMessageList: "/pushMessage/list",
          pushMessageUpdate: "/pushMessage/update",
          pushMessageZoneTypeList: "/pushMessage/zone/type/list",
          pushMessageActionTypeList: "/pushMessage/action/type/list",

          exportPoi: "/export/poi",
          exportTag: "/export/tag",
          exportCategory: "/export/category",
          exportEventCCS: "/export/event/ccs",
          exportEventCCSData: "/export/event/ccs/data",

          importPoi: "/import/poi",
          importBeacon: "/import/beacon",
          importPoiMonitor: "/import/poi/monitor",
          importCategory: "/import/category",
          importTag: "/import/tag",
          importEventCCS: "/import/event/ccs",
          importPlanningBeacon: "/import/beacon/planning",
          importPresetBeacon: "/import/beacon/preset",
          importEventBasicInfo: "/import/event/basicInfo",
          importEventVisual: "/import/event/visual",
          eventStatusPublish: "/event/status/publish",

          uploadImages: "/upload/images",
          uploadImage: "/upload/image",

          arwizLogin: "/arwiz/login",
          sendForgotPasswordEmail: "/auth/sendForgotPasswordEmail",
          getAuthKey: "/auth/key",
          forgotPassword: "/auth/forgotPassword",
          listForProject: "/systemFunction/getListForProject",

          eventCreate: "/event/create",
          eventDelete: "/event/delete",
          eventDetail: "/event/detail",
          eventList: "/event/list",
          eventStatusList: "/event/status/list",
          eventTypeList: "/event/type/list",
          eventUpdate: "/event/update",
          eventAdmissionList: "/event/admission/list",
          eventButtonList: "/event/button/list",
          eventLabelList: "/event/label/list",

          eventAddressDetail: "/event/address/detail",
          eventAddressSave: "/event/address/save",

          eventHighlightDetail: "/event/highlight/detail",
          eventHighlightSave: "/event/highlight/save",

          eventProgrammeDetail: "/event/programme/detail",
          eventProgrammeSave: "/event/programme/save",

          eventSectionDetail: "/event/section/detail",
          eventSectionSave: "/event/section/save",

          eventShowDetail: "/event/show/detail",
          eventShowSave: "/event/show/save",

          eventCCSDetail: "/event/ccs/detail",
          eventCCSSave: "/event/ccs/save",

          eventTalkForumDetail: "/event/talkForum/detail",
          eventTalkForumSave: "/event/talkForum/save",

          eventVisualDetail: "/event/visual/detail",
          eventVisualSave: "/event/visual/save",

          eventScheduleDetail: "/event/schedule/detail",
          eventScheduleSave: "/event/schedule/save",

          eventSupplementaryDetail: "/event/supplementary/detail",
          eventSupplementarySave: "/event/supplementary/save",

          highlightEventCreate: "/highlight/event/create",
          highlightEventDelete: "/highlight/event/delete",
          highlightEventList: "/highlight/event/list",
          highlightEventUpdate: "/highlight/event/update",

          eventTypeCreate: "/event/type/create",
          eventTypeDelete: "/event/type/delete",
          eventTypeDetail: "/event/type/detail",
          eventTypeList: "/event/type/list",
          eventTypeUpdate: "/event/type/update",

          eventVenueCreate: "/venue/create",
          eventVenueDelete: "/venue/delete",
          eventVenueDetail: "/venue/detail",
          eventVenueList: "/venue/list",
          eventVenueUpdate: "/venue/update",
          eventVenueExists: "/venue/exists",

          layerCreate: "/layer/create",
          layerDelete: "/layer/delete",
          layerDetail: "/layer/detail",
          layerList: "/layer/list",
          layerUpdate: "/layer/update",
          layerUpdateOrder: "/layer/updateOrder",

          backupCreate: "/backup/create",
          backupDelete: "/backup/delete",
          backupRestore: "/backup/restore",
          backupList: "/backup/list",

          formBuildLogin: "/formBuild/login",
          formBuildSurveyList: "/formBuild/survey/list",
          formBuildPollingList: "/formBuild/polling/list",

          clientSystemLogin: "/auth/clientSystemLogin",
          venueTypeList: "/venue/type/list",

          ctrEventList: "/ctr/event/list",
          ctrTagList: "/ctr/tag/list",

          hotEventList: "/hot/event/list",
          hotEventSave: "/hot/event/save",

          hotTagList: "/hot/tag/list",
          hotTagSave: "/hot/tag/save",
          currencyList: "/currency/list",

          pushMessageRuleDetail: "/pushMessageRule/detail",
          pushMessageRuleSave: "/pushMessageRule/save",
          pushMessageRuleType: "/pushMessageRule/type",

          rawData: "/rawData/daysDownload",
          rawDataCheck: "/rawData/checkDownload",

          assetServiceGetToken: "/assetService/getToken",
          assetZoneList: "/assetZone/list",
          assetZoneUpload: "/assetZone/upload",
          assetZoneExport: "/assetZone/download",

          assetCreate: "/asset/create",
          assetDelete: "/asset/delete",
          assetDetail: "/asset/detail",
          assetExport: "/asset/export",
          assetImport: "/asset/import",
          assetList: "/asset/list",
          assetUpdate: "/asset/update",

          imdfDetail: "/imdf/detail",
          imdfSave: "/imdf/save",
          geofenceUpload: "/geofence/upload",
          geofenceDetail: "/geofence/detail",
          geofenceDownload: "/geofence/download",
          geofenceSave: "/geofence/save",

          navigationPromptDetail: "/navigation/prompt/detail",
          navigationPromptSave: "/navigation/prompt/save",

          pathDetail: "/path/detail",
          pathUpdate: "/path/update",
          pathDelete: "/path/delete",

          buildingAreaUpload: "/buildingArea/upload",
          buildingAreaDetail: "/buildingArea/detail",
          buildingAreaDownload: "/buildingArea/download",
          buildingAreaSave: "/buildingArea/save",

        }
      }
    },
    methods: {
      checkPermission(permission) {
        if (this.$store.state && this.$store.state.userInfo && this.$store.state.userInfo.systemActions) {
          let actions = this.$store.state.userInfo.systemActions;
          let found = false;
          actions.forEach(item => { if (item.funcCode === permission) { found = true } });
          if (found) return found;
        }
        return false;
      },
      setFormData(data) {
        var params = new URLSearchParams();
        for (var key in data) {
          if (data[key] !== null && data[key] !== undefined) {
            params.append(key, data[key]);
          }
        }
        return params;
      },
      getObject(object, languageId) {
        return !object || object.length == 0 ? {} : object.find(o => o.languageId == languageId);
      },
      timeoutEvent() {
        this.$router.push({ path: "/" });
      },
      showWarning() {
        var that = this;
        if (this.multipleSelection.length != 0) {
          this.$store.commit("setwarning", {
            string: this.$i18n.t("message.deleteContent"),
            boolean: true,
            button: [{
              name: this.$i18n.t("message.Confirm"),
              callBack: function () {
                that.$store.commit("setwarning", { string: "", boolean: false });
                that.deleteList();
              }
            }, {
              name: this.$i18n.t("message.Cancel"),
              callBack: function () { that.$store.commit("setwarning", { string: "", boolean: false }); }
            }]
          });
        }
      },
      sortChange: function (val) {
        if (val.order == 'ascending') {
          this.sortType = 'ASC';
          this.sortField = val.prop;
        } else if (val.order == "descending") {
          this.sortType = 'DESC';
          this.sortField = val.prop;
        } else {
          this.sortType = 'ASC';
          this.sortField = 'id';
        }
        this.init();
      },
      handleSizeChange: function (val) {
        this.pagesize = val;
        this.init();
      },
      handleCurrentChange: function (val) {
        this.page = val - 1;
        this.init();
      },
      handleSelectionChange: function (val) {
        this.multipleSelection = val;
      },
      cancel: function () {
        this.$store.commit("setwarning", { string: "", boolean: false });
      },
      getAuthObj() {
        let obj = {};
        obj.accessToken = this.$store.state.userInfo.tokenType + " " + this.$store.state.userInfo.accessToken;
        obj.projectId = this.$store.state.projectId;
        obj.lang = "en_US"
        return obj;
      },
      getMapAuthObj() {
        let obj = {};
        obj.accessToken = this.$store.state.userInfo.tokenType + " " + this.$store.state.userInfo.mapToken;
        obj.apiDomain = this.mapApiDomain;
        obj.lang = "en_US"
        return obj;
      },
      getAssetAuthObj() {
        let obj = {};
        obj.accessToken = this.$store.state.userInfo.tokenType + " " + this.$store.state.userInfo.assetToken;
        obj.apiDomain = this.assetApiDomain;
        obj.lang = "en_US"
        return obj;
      },
      dateFormat(date) {
        var long = new Date(date).getTime();
        if (!long) {
          return ""
        }
        var timeStamp = new Date(long);
        var year = timeStamp.getFullYear();
        var shortYear = year.toString().substring(2);
        var month = timeStamp.getMonth() + 1;
        if (month < 10) {
          month = "0" + month;
        }
        var date = timeStamp.getDate();
        if (date < 10) {
          date = "0" + date;
        }
        var hour = timeStamp.getHours();
        if (hour < 10) {
          hour = "0" + hour;
        }
        var seconds = timeStamp.getSeconds();
        if (seconds < 10) {
          seconds = "0" + seconds;
        }
        var minutes = timeStamp.getMinutes();
        if (minutes < 10) {
          minutes = "0" + minutes;
        }
        return year + '-' + month + '-' + date + ' ' + hour + ":" + minutes + ":" + seconds
      },
      dateFormatNextYear(date) {
        var long = new Date(date).getTime();
        if (!long) {
          return ""
        }
        var timeStamp = new Date(long);
        var year = timeStamp.getFullYear() + 1;
        var shortYear = year.toString().substring(2);
        var month = timeStamp.getMonth() + 1;
        if (month < 10) {
          month = "0" + month;
        }
        var date = timeStamp.getDate();
        if (date < 10) {
          date = "0" + date;
        }
        var hour = timeStamp.getHours();
        if (hour < 10) {
          hour = "0" + hour;
        }
        var seconds = timeStamp.getSeconds();
        if (seconds < 10) {
          seconds = "0" + seconds;
        }
        var minutes = timeStamp.getMinutes();
        if (minutes < 10) {
          minutes = "0" + minutes;
        }
        return year + '-' + month + '-' + date + ' ' + hour + ":" + minutes + ":" + seconds
      }
    },
    computed: {
    }
  }

};